import jobOffers from '../tempData/jobOffers';

const offers = jobOffers.reduce((acc, el) => {
  return acc.concat(el);
}, []);

export default offers;
